"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1314,2428],{

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "m5.894 5 3.92-3.92A.632.632 0 1 0 8.92.185L5 4.105 1.08.186a.632.632 0 0 0-.895.895L4.105 5 .186 8.92a.632.632 0 1 0 .895.895L5 5.895l3.92 3.92a.632.632 0 1 0 .895-.895z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 15814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.scss.js




var bannerHeight = "72px";
var bannerTextLinHeight = "24px";
var StyledBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1o7tdaf0"
})("min-height:", bannerHeight, ";display:flex;justify-content:center;position:relative;&.top-margin{margin-top:", constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px;}.banner-content{display:flex;width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;.image-wrapper{display:flex;flex-grow:0;.banner-image{min-height:", bannerHeight, ";}}&.with-sticky-images{width:auto;align-items:center;.banner-image{height:", bannerTextLinHeight, ";}}.banner-text-and-cta{display:flex;justify-content:center;align-items:center;flex-grow:1;.banner-text-and-link{display:flex;align-items:center;.banner-text{display:inline;font-size:1rem;line-height:", bannerTextLinHeight, ";text-align:center;}.banner-icon-wrapper{display:flex;margin-right:8px;.picture-component{display:flex;}}}.banner-cta-wrapper{display:inline-block;margin-left:24px;min-width:190px;.ladda-button{padding:12px 20px;background:", colors/* default.white */.Z.white, ";", function(param) {
    var buttonTextColor = param.buttonTextColor;
    return buttonTextColor && "color: ".concat(colors/* default */.Z[buttonTextColor], ";");
}, "}}}}.close-icon-wrapper{position:absolute;top:10px;right:10px;cursor:pointer;svg{width:12px;height:12px;path{fill:", colors/* default.white */.Z.white, ";}}}&.hide-banner{display:none;}@media (max-width:", vp_sizes/* MIN_HEADER_DESKTOP_MENU */.dD, "px){&.top-margin{margin-top:0px;}.banner-content{width:initial;.image-wrapper{.banner-picture{display:flex;align-items:center;.banner-image{height:50px;}}}.banner-text-and-cta{margin-left:20px;margin-right:35px;justify-content:center;flex-grow:0;flex-direction:column;.banner-cta-wrapper{margin-left:0;min-width:unset;align-self:start;.secondary-button{font-size:0.8125rem;}}.banner-text-and-link{display:flex;align-items:center;flex-direction:column;gap:10px;.banner-text{font-size:1rem;text-align:left;font-weight:400;}.banner-link{font-size:1rem;}}}}}@media (max-width:600px){.banner-content{.banner-text-and-cta{.banner-text-and-link{display:inline-block;text-align:center;max-width:274px;.banner-text{font-size:0.8125rem;}.banner-link{font-size:0.8125rem;}.banner-cta-wrapper{margin-left:16px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/default-props.js

/* harmony default export */ var default_props = ({
    bannerText: "<monday-bold>Is your team working from home?</monday-bold> Use monday.com to get remote work done",
    bannerCta: "Start Collaborating",
    withCloseIcon: true,
    theme: "dodger-blue",
    buttonConfig: {
        buttonSize: button_component.SM
    },
    extraData: {}
});

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var BANNER_EXPIRE_DAYS = 7;
var SIGNUP_BANNER_PLACEMENT = "top_with_background_banner";
var Banner = function(props) {
    var bannerText = props.bannerText, bannerLinkData = props.bannerLinkData, bannerCta = props.bannerCta, bannerleftImage = props.bannerleftImage, bannerRightImage = props.bannerRightImage, withCloseIcon = props.withCloseIcon, theme = props.theme, buttonConfig = props.buttonConfig, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, placement = props.placement, hideBannerWithBackground = props.hideBannerWithBackground, stickImagesToText = props.stickImagesToText, extraData = props.extraData, bannerHeight = props.bannerHeight, mobileBannerText = props.mobileBannerText, bannerIcon = props.bannerIcon, bannerIconHeight = props.bannerIconHeight;
    var ref = (0,react.useState)(hideBannerWithBackground && withCloseIcon), hideBanner = ref[0], setHideBanner = ref[1]; // for now only banner that can be closed use the cookie
    var getThemes = function() {
        return _object_spread_props(_object_spread({}, segments_service/* themes */.np), {
            "dodger-blue": {
                color: colors/* default.white */.Z.white,
                background: colors/* default.dodger-blue */.Z["dodger-blue"]
            }
        });
    };
    var getThemeStyle = function() {
        return getThemes()[theme] || {};
    };
    var themeStyle = getThemeStyle();
    var onCloseBanner = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TOP_BANNER_CLOSED_CLICK);
        (0,cookies_service/* setCookie */.d8)(cookies.HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME, true, {
            expires: BANNER_EXPIRE_DAYS
        });
        setHideBanner(true);
    };
    var onBannerLinkClicked = function(link) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.BANNER_LINK_CLICKED, {
            kind: link
        });
    };
    var getBannerButtonProps = function() {
        var buttonProps = {
            ctaText: bannerCta,
            placement: placement || SIGNUP_BANNER_PLACEMENT,
            buttonSpinnerColor: themeStyle.background,
            parentSegment: "Banner",
            useCtaText: true,
            extraData: extraData
        };
        if (isMobileOrTabletBrowser) {
            var MOBILE_NOT_ALLOWED_BUTTON_TYPES = [
                button_consts/* REGULAR_BUTTON_TYPE */.ys
            ];
            var buttonType = buttonConfig.buttonType;
            var buttonDisplayType = buttonConfig.buttonDisplayType;
            var extraButtonProps = {};
            if (MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonType)) {
                extraButtonProps.buttonType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            if (buttonConfig.buttonType === button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9 && MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonDisplayType)) {
                extraButtonProps.buttonDisplayType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            buttonProps = _object_spread_props(_object_spread({}, buttonProps, extraButtonProps), {
                buttonSize: button_component.SM
            });
        }
        return buttonProps;
    };
    var getBannerText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
            className: "banner-text",
            text: mobileBannerText && isMobileOrTabletBrowser ? mobileBannerText : bannerText,
            style: bannerIcon ? {
                textAlign: "left"
            } : {}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        className: classnames_default()("banner", {
            "hide-banner": hideBanner,
            "top-margin": isSecondaryMenuNeeded
        }),
        buttonTextColor: theme,
        style: bannerHeight ? _object_spread_props(_object_spread({}, themeStyle), {
            minHeight: bannerHeight
        }) : themeStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("banner-content", {
                    "with-sticky-images": stickImagesToText
                }),
                children: [
                    bannerleftImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerleftImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "banner-text-and-cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "banner-text-and-link",
                            style: bannerIcon ? {
                                display: "flex",
                                "flex-direction": "row"
                            } : {},
                            children: [
                                bannerIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-icon-wrapper",
                                    style: {
                                        height: bannerIconHeight
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: bannerIcon
                                    })
                                }),
                                getBannerText(),
                                bannerLinkData && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "banner-link",
                                    href: bannerLinkData.src,
                                    style: {
                                        color: themeStyle.color
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return onBannerLinkClicked(bannerLinkData.src);
                                    },
                                    children: bannerLinkData.text
                                }),
                                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-cta-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig, getBannerButtonProps()))
                                })
                            ]
                        })
                    }),
                    bannerRightImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerRightImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    })
                ]
            }),
            withCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-icon-wrapper",
                onClick: onCloseBanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
            })
        ]
    });
};
Banner.defaultProps = default_props;
/* harmony default export */ var banner = ((0,generic_config_context/* withGenericConfig */.P)(Banner));


/***/ }),

/***/ 43787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gv": function() { return /* binding */ AI_MENU_ID; },
  "xN": function() { return /* binding */ CUSTOMERS_MENU_ID; },
  "Nl": function() { return /* binding */ DESKTOP_HEADER_BASE_CLASS_NAME; },
  "Qc": function() { return /* binding */ FEATURES_MENU_ID; },
  "wP": function() { return /* binding */ PLATFORM_MENU_ID; },
  "VG": function() { return /* binding */ PRODUCTS_MENU_ID; },
  "Gu": function() { return /* binding */ RESOURCES_MENU_ID; },
  "e1": function() { return /* binding */ SOLUTIONS_MENU_ID; },
  "tS": function() { return /* binding */ SectionsHeadersMenuItemsMapping; },
  "$Q": function() { return /* binding */ TEAMS_MENU_ID; },
  "sI": function() { return /* binding */ USE_CASES_MENU_ID; },
  "EH": function() { return /* binding */ isDesktopMinisiteSecondaryMenuActive; },
  "VK": function() { return /* binding */ mobileProductsSectionMenuItems; },
  "Y0": function() { return /* binding */ shouldRenderSecondaryMenu; }
});

// UNUSED EXPORTS: BY_BUSINESS_SIZE_SECTION_ID, BY_INDUSTRY_SECTION_ID, BY_TEAM_SECTION_ID, ICON_TYPES, KEY_FEATURES_SECTION_ID, MENU_SECTION_CLASSNAMES, MENU_SECTION_ITEM_TYPE, PRODUCTS_MORE_SECTION_ID, PRODUCTS_PRODUCTS_SECTION_ID, RESOURCES_CONNECT_SECTION_ID, RESOURCES_EXPLORE_SECTION_ID, RESOURCES_LEARN_SECTION_ID, TOP_STORIES_SECTION_ID

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/header/workcanvas_colored.svg
var _g, _defs;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgWorkcanvasColored = function SvgWorkcanvasColored(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_10556_100)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M1.936 1.953h16.128v16.282H1.936z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M17.195 2.831H2.805v14.526h14.39zM1.936 1.953v16.282h16.128V1.953z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 0H20v4.559h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13.878h-2.776V3.68h2.776zM15.484 0v4.559H20V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h4.516v4.559H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646.878H.87V3.68h2.776zM0 0v4.559h4.516V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 15.441H20V20h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13 16.319h-2.776v2.803h2.776zm-3.646-.878V20H20v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 15.441h4.516V20H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646 16.319H.87v2.803h2.776zM0 15.44V20h4.516v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        d: "M10.208 14.694q-1.111 0-1.94-.363a4 4 0 0 1-1.362-1.011 4.2 4.2 0 0 1-.814-1.422 5.3 5.3 0 0 1-.266-1.66v-.3q0-.885.282-1.69a4.4 4.4 0 0 1 .83-1.454 3.85 3.85 0 0 1 1.36-.995q.83-.363 1.895-.363 1.158 0 2.05.458.893.442 1.424 1.248.532.805.595 1.849h-2.457a1.55 1.55 0 0 0-.47-.98q-.391-.41-1.142-.41-.626 0-1.05.315-.405.315-.61.87-.203.552-.203 1.31 0 .695.188 1.265a1.8 1.8 0 0 0 .595.869q.422.3 1.095.3.501 0 .845-.174.36-.19.564-.506a1.7 1.7 0 0 0 .266-.758h2.442q-.048 1.074-.595 1.896a3.8 3.8 0 0 1-1.456 1.264q-.908.442-2.066.442"
    }))), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_10556_100"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var workcanvas_colored = (SvgWorkcanvasColored);

;// CONCATENATED MODULE: ./static/svg/header/workforms_colored.svg
var _path, _path2, workforms_colored_defs;
function workforms_colored_extends() {
    workforms_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return workforms_colored_extends.apply(this, arguments);
}

var SvgWorkformsColored = function SvgWorkformsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", workforms_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 20,
        fill: "none",
        viewBox: "0 0 15 20"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_642_352343)",
        fillRule: "evenodd",
        d: "M2.885 0a2.885 2.885 0 0 0 0 5.77h9.23a2.885 2.885 0 0 0 0-5.77zm0 6.92a2.885 2.885 0 0 0 0 5.77h5.192a2.885 2.885 0 0 0 0-5.77z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_642_352343)",
        fillRule: "evenodd",
        d: "M5.77 2.885a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m0 6.92a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m-2.885 9.81a2.885 2.885 0 1 0 0-5.77 2.885 2.885 0 0 0 0 5.77",
        clipRule: "evenodd"
    })), workforms_colored_defs || (workforms_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_642_352343",
        x1: -5.192,
        x2: 1.082,
        y1: -4.326,
        y2: 18.73,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#DE0B76"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#F58A25",
        stopOpacity: 0
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_642_352343",
        x1: 2.308,
        x2: 16.418,
        y1: -1.154,
        y2: 21.548,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#C21E71"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#DE5948",
        stopOpacity: 0.457
    })))));
};
/* harmony default export */ var workforms_colored = (SvgWorkformsColored);

;// CONCATENATED MODULE: ./static/svg/header/marketing_colored.svg
var marketing_colored_path, marketing_colored_path2;
function marketing_colored_extends() {
    marketing_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return marketing_colored_extends.apply(this, arguments);
}

var SvgMarketingColored = function SvgMarketingColored(props) {
    return /*#__PURE__*/ react.createElement("svg", marketing_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), marketing_colored_path || (marketing_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.5,
        d: "M1.25-1.25h2.707",
        transform: "matrix(.34684 .93793 -.95008 .312 10.22 17.544)"
    })), marketing_colored_path2 || (marketing_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M7.942 17.543 7 14.435 18.306 6l3.062 10.729z"
    })));
};
/* harmony default export */ var marketing_colored = (SvgMarketingColored);

;// CONCATENATED MODULE: ./static/svg/header/dev_colored.svg
var dev_colored_path;
function dev_colored_extends() {
    dev_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_colored_extends.apply(this, arguments);
}

var SvgDevColored = function SvgDevColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), dev_colored_path || (dev_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.175,
        d: "m10.835 8.999-4.834 4.826M10.897 18.688l-4.834-4.826M16.914 8.999l4.833 4.826M16.851 18.688l4.834-4.826"
    })));
};
/* harmony default export */ var dev_colored = (SvgDevColored);

;// CONCATENATED MODULE: ./static/svg/header/it_colored_1.svg
var it_colored_1_path;
function it_colored_1_extends() {
    it_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return it_colored_1_extends.apply(this, arguments);
}

var SvgItColored1 = function SvgItColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", it_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), it_colored_1_path || (it_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 19h15M21 10H6M19 8v4M10 17v4"
    })));
};
/* harmony default export */ var it_colored_1 = (SvgItColored1);

;// CONCATENATED MODULE: ./static/svg/header/operations_colored.svg
var _circle, _circle2;
function operations_colored_extends() {
    operations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return operations_colored_extends.apply(this, arguments);
}

var SvgOperationsColored = function SvgOperationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", operations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 6,
        stroke: "#000",
        strokeWidth: 2
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 2.1,
        stroke: "#000",
        strokeWidth: 1.8
    })));
};
/* harmony default export */ var operations_colored = (SvgOperationsColored);

;// CONCATENATED MODULE: ./static/svg/header/sales_colored_1.svg
var sales_colored_1_path;
function sales_colored_1_extends() {
    sales_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return sales_colored_1_extends.apply(this, arguments);
}

var SvgSalesColored1 = function SvgSalesColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", sales_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), sales_colored_1_path || (sales_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M5 20.5 9.5 15l5 3 6-10m0 0L15 9.5M20.5 8l1.5 5"
    })));
};
/* harmony default export */ var sales_colored_1 = (SvgSalesColored1);

;// CONCATENATED MODULE: ./static/svg/header/hr_colored_1.svg
var hr_colored_1_path;
function hr_colored_1_extends() {
    hr_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hr_colored_1_extends.apply(this, arguments);
}

var SvgHrColored1 = function SvgHrColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", hr_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), hr_colored_1_path || (hr_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M18 22v-9M10 22v-9M18 8V7M10 8V7"
    })));
};
/* harmony default export */ var hr_colored_1 = (SvgHrColored1);

;// CONCATENATED MODULE: ./static/svg/header/enterprise_colored_1.svg
var enterprise_colored_1_path;
function enterprise_colored_1_extends() {
    enterprise_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return enterprise_colored_1_extends.apply(this, arguments);
}

var SvgEnterpriseColored1 = function SvgEnterpriseColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", enterprise_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), enterprise_colored_1_path || (enterprise_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M2.857 25.143h22.286M18.434 6.733h-8.72v18.41h8.72zM23.019 15.453h-3.876v9.69h3.876zM9.304 15.453H5.43v9.69h3.875zM15.714 3.714h-3.428v2.572h3.428zM14 3.714V2M14.857 10.571h-1.714M14.857 14h-1.714M14.857 17.429h-1.714"
    })));
};
/* harmony default export */ var enterprise_colored_1 = (SvgEnterpriseColored1);

;// CONCATENATED MODULE: ./static/svg/header/retail_colored.svg
var retail_colored_g, retail_colored_defs;
function retail_colored_extends() {
    retail_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return retail_colored_extends.apply(this, arguments);
}

var SvgRetailColored = function SvgRetailColored(props) {
    return /*#__PURE__*/ react.createElement("svg", retail_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), retail_colored_g || (retail_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1279)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M2.143 12.143v6.429a.715.715 0 0 0 .714.714h14.286a.715.715 0 0 0 .714-.715v-6.428M11.428 12.143v7.143M2.143 14.286h9.285M.714 5.714l2.143-5h14.286l2.143 5zM6.828 5.714v1.429A2.857 2.857 0 0 1 3.971 10h-.4A2.857 2.857 0 0 1 .714 7.143V5.714"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13.214 5.714v1.429A2.857 2.857 0 0 1 10.357 10h-.715a2.857 2.857 0 0 1-2.857-2.857V5.714M19.286 5.714v1.429A2.857 2.857 0 0 1 16.428 10h-.357a2.857 2.857 0 0 1-2.857-2.857V5.714"
    }))), retail_colored_defs || (retail_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1279"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var retail_colored = (SvgRetailColored);

;// CONCATENATED MODULE: ./static/svg/header/construction_colored.svg
var construction_colored_path;
function construction_colored_extends() {
    construction_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return construction_colored_extends.apply(this, arguments);
}

var SvgConstructionColored = function SvgConstructionColored(props) {
    return /*#__PURE__*/ react.createElement("svg", construction_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), construction_colored_path || (construction_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M18.394 21c-1.091-3.152-4.121-5.455-7.636-5.455C7.242 15.545 4.09 17.848 3 21M10.636 4.636V1M3.97 8.152h13.333M5.667 9.485c.12 2.667 2.303 4.848 4.97 4.848 2.787 0 4.969-2.181 4.969-4.97V7.183c0-2.788-2.182-4.97-4.97-4.97-2.666 0-4.848 2.182-4.97 4.849z"
    })));
};
/* harmony default export */ var construction_colored = (SvgConstructionColored);

;// CONCATENATED MODULE: ./static/svg/header/government-icon.svg
var government_icon_g, government_icon_defs;
function government_icon_extends() {
    government_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return government_icon_extends.apply(this, arguments);
}

var SvgGovernmentIcon = function SvgGovernmentIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", government_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), government_icon_g || (government_icon_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.25,
        clipPath: "url(#clip0_26_455)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M17.05 11.354H1.102l7.975-4.557zM1.101 17.05h15.95M2.24 11.354v5.697M5.658 11.354v5.697M9.076 11.354v5.697M12.494 11.354v5.697M15.912 11.354v5.697"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M4.519 9.381V7.367a4.557 4.557 0 0 1 9.114 0V9.38M9.076 2.81V1.1"
    }))), government_icon_defs || (government_icon_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_26_455"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h18v18H0z"
    })))));
};
/* harmony default export */ var government_icon = (SvgGovernmentIcon);

;// CONCATENATED MODULE: ./static/svg/header/media_colored.svg
var media_colored_g, media_colored_defs;
function media_colored_extends() {
    media_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return media_colored_extends.apply(this, arguments);
}

var SvgMediaColored = function SvgMediaColored(props) {
    return /*#__PURE__*/ react.createElement("svg", media_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), media_colored_g || (media_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1292)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M5 9.286A4.286 4.286 0 1 0 5 .714a4.286 4.286 0 0 0 0 8.572M15 9.286a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714M14.286 12.857H6.429c-.79 0-1.429.64-1.429 1.429v3.571c0 .79.64 1.429 1.429 1.429h7.857c.789 0 1.428-.64 1.428-1.429v-3.571c0-.79-.64-1.429-1.428-1.429M19.286 14.286v3.571"
    }))), media_colored_defs || (media_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1292"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var media_colored = (SvgMediaColored);

;// CONCATENATED MODULE: ./static/svg/header/small_business_colored_1.svg
var small_business_colored_1_path, small_business_colored_1_path2;
function small_business_colored_1_extends() {
    small_business_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return small_business_colored_1_extends.apply(this, arguments);
}

var SvgSmallBusinessColored1 = function SvgSmallBusinessColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", small_business_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), small_business_colored_1_path || (small_business_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M22 6H7v16h15zM13 11h3"
    })), small_business_colored_1_path2 || (small_business_colored_1_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M12 22v-7h5v7"
    })));
};
/* harmony default export */ var small_business_colored_1 = (SvgSmallBusinessColored1);

;// CONCATENATED MODULE: ./static/svg/header/nonprofit_colored.svg
var nonprofit_colored_path;
function nonprofit_colored_extends() {
    nonprofit_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return nonprofit_colored_extends.apply(this, arguments);
}

var SvgNonprofitColored = function SvgNonprofitColored(props) {
    return /*#__PURE__*/ react.createElement("svg", nonprofit_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), nonprofit_colored_path || (nonprofit_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.703,
        d: "m14.212 13.387-4.197-3.883c-2.288-2.298 1.05-6.748 4.197-3.148 3.149-3.589 6.518.86 4.198 3.148zM10.678 18.637c.516.258 2.28.774 3.097.774 1.806 0 2.394-.318 3.097-.516 1.032-.292 1.458-.997 1.568-1.324m0 0c.074-.223.125.276 0-.225-.517-2.064-2.6-.291-4.665-.55-2.065-.257-4.646-1.514-5.678-1.514S5 16.022 5 17.346c0 1 .774 2.065 2.065 3.064s3.87 1.806 6.452 1.806c3.145 0 4.645-1.066 5.935-1.806.448-.257 3.613-2.84 3.871-3.613.333-1-.234-1.311-.774-1.515-.774-.292-1.419.5-2.064.999-1.29.999-1.29 1.066-2.045 1.29"
    })));
};
/* harmony default export */ var nonprofit_colored = (SvgNonprofitColored);

;// CONCATENATED MODULE: ./static/svg/header/docs_colored.svg
var docs_colored_path, docs_colored_path2, _path3;
function docs_colored_extends() {
    docs_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return docs_colored_extends.apply(this, arguments);
}

var SvgDocsColored = function SvgDocsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", docs_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), docs_colored_path || (docs_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M5 17.273V4a1 1 0 0 1 1-1h6.728a1 1 0 0 1 .753.342l3.272 3.74A1 1 0 0 1 17 7.74v9.533a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"
    })), docs_colored_path2 || (docs_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M13.143 7.114V3.447c0-.157.194-.232.299-.115L16.742 7c.1.11.021.286-.127.286h-3.3a.17.17 0 0 1-.172-.172Z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.857 9.962h4.104M7.682 13.409h5.545"
    })));
};
/* harmony default export */ var docs_colored = (SvgDocsColored);

;// CONCATENATED MODULE: ./static/svg/header/forms_icon_new.svg
var forms_icon_new_path, forms_icon_new_path2, forms_icon_new_path3, _path4, _path5, _path6, _path7, _path8, _path9;
function forms_icon_new_extends() {
    forms_icon_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return forms_icon_new_extends.apply(this, arguments);
}

var SvgFormsIconNew = function SvgFormsIconNew(props) {
    return /*#__PURE__*/ react.createElement("svg", forms_icon_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), forms_icon_new_path || (forms_icon_new_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 6.405a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), forms_icon_new_path2 || (forms_icon_new_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 6.405H18Z"
    })), forms_icon_new_path3 || (forms_icon_new_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 6.405H18"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 10.804a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 10.804H18Z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 10.804H18"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 15.203a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 15.203H18Z"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 15.203H18"
    })));
};
/* harmony default export */ var forms_icon_new = (SvgFormsIconNew);

;// CONCATENATED MODULE: ./static/svg/header/gantt_colored.svg
var gantt_colored_path;
function gantt_colored_extends() {
    gantt_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gantt_colored_extends.apply(this, arguments);
}

var SvgGanttColored = function SvgGanttColored(props) {
    return /*#__PURE__*/ react.createElement("svg", gantt_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), gantt_colored_path || (gantt_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 6H2M14 11H6M19.242 16H12"
    })));
};
/* harmony default export */ var gantt_colored = (SvgGanttColored);

;// CONCATENATED MODULE: ./static/svg/header/ai-icon.svg
var ai_icon_path, ai_icon_path2;
function ai_icon_extends() {
    ai_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return ai_icon_extends.apply(this, arguments);
}

var SvgAiIcon = function SvgAiIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", ai_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), ai_icon_path || (ai_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        d: "M8.797 6.616a.213.213 0 0 1 .406 0l1.496 4.55a.21.21 0 0 0 .136.135l4.549 1.496a.213.213 0 0 1 0 .406l-4.55 1.496a.21.21 0 0 0-.135.136l-1.496 4.549a.213.213 0 0 1-.406 0l-1.496-4.55a.21.21 0 0 0-.136-.135l-4.549-1.496a.213.213 0 0 1 0-.406l4.55-1.496a.21.21 0 0 0 .135-.136z"
    })), ai_icon_path2 || (ai_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M16.297 2.616a.213.213 0 0 1 .406 0l.63 1.915a.21.21 0 0 0 .136.136l1.915.63a.213.213 0 0 1 0 .406l-1.915.63a.21.21 0 0 0-.137.136l-.63 1.915a.213.213 0 0 1-.405 0l-.63-1.915a.21.21 0 0 0-.136-.136l-1.915-.63a.213.213 0 0 1 0-.406l1.915-.63a.21.21 0 0 0 .136-.136z"
    })));
};
/* harmony default export */ var ai_icon = (SvgAiIcon);

;// CONCATENATED MODULE: ./static/svg/header/kanban_colored.svg
var kanban_colored_path, _rect;
function kanban_colored_extends() {
    kanban_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return kanban_colored_extends.apply(this, arguments);
}

var SvgKanbanColored = function SvgKanbanColored(props) {
    return /*#__PURE__*/ react.createElement("svg", kanban_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), kanban_colored_path || (kanban_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M4 3.5h4.5V14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5ZM13.5 3.5H18a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
    })), _rect || (_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 5,
        height: 15,
        x: 8.5,
        y: 3.5,
        stroke: "#000",
        strokeLinejoin: "round",
        rx: 0.5
    })));
};
/* harmony default export */ var kanban_colored = (SvgKanbanColored);

;// CONCATENATED MODULE: ./static/svg/header/automations_colored.svg
var automations_colored_rect, automations_colored_path, automations_colored_path2, automations_colored_path3;
function automations_colored_extends() {
    automations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return automations_colored_extends.apply(this, arguments);
}

var SvgAutomationsColored = function SvgAutomationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", automations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), automations_colored_rect || (automations_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 12.047,
        height: 10.951,
        x: 5.183,
        y: 6.287,
        stroke: "#000",
        rx: 2.259
    })), automations_colored_path || (automations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M8.974 10.072v2.285M13.35 10.072v2.285"
    })), automations_colored_path2 || (automations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10.701c0-.624.506-1.13 1.13-1.13h1.06v4.381H4.13A1.13 1.13 0 0 1 3 12.823zM17.234 9.572h1.061c.624 0 1.13.505 1.13 1.13v2.121a1.13 1.13 0 0 1-1.13 1.13h-1.06z"
    })), automations_colored_path3 || (automations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M11.162 3.5v2.285"
    })));
};
/* harmony default export */ var automations_colored = (SvgAutomationsColored);

;// CONCATENATED MODULE: ./static/svg/header/integrations_colored.svg
var integrations_colored_path, integrations_colored_path2, integrations_colored_path3;
function integrations_colored_extends() {
    integrations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return integrations_colored_extends.apply(this, arguments);
}

var SvgIntegrationsColored = function SvgIntegrationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", integrations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), integrations_colored_path || (integrations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m3.5 8.735 3.036 3.036M7.738 4.5l3.036 3.036M14.393 14.981l2.753 2.754"
    })), integrations_colored_path2 || (integrations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "m5.745 12.735 6.78-6.78 3.67 3.671c.89.89.89 2.333 0 3.223l-3.556 3.556a2.28 2.28 0 0 1-3.223 0z"
    })), integrations_colored_path3 || (integrations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m4.031 14.342 9.5-9.328"
    })));
};
/* harmony default export */ var integrations_colored = (SvgIntegrationsColored);

;// CONCATENATED MODULE: ./static/svg/header/dashboards_colored.svg
var dashboards_colored_rect, dashboards_colored_path;
function dashboards_colored_extends() {
    dashboards_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dashboards_colored_extends.apply(this, arguments);
}

var SvgDashboardsColored = function SvgDashboardsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dashboards_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), dashboards_colored_rect || (dashboards_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 14,
        height: 14,
        x: 3.5,
        y: 3.5,
        stroke: "#000",
        rx: 1.375
    })), dashboards_colored_path || (dashboards_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.183 14.687V11M10.936 14.687V8.188M14.69 14.687V6.312"
    })));
};
/* harmony default export */ var dashboards_colored = (SvgDashboardsColored);

;// CONCATENATED MODULE: ./static/svg/header/project_management_colored_2.svg
var project_management_colored_2_path, project_management_colored_2_path2, project_management_colored_2_rect;
function project_management_colored_2_extends() {
    project_management_colored_2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return project_management_colored_2_extends.apply(this, arguments);
}

var SvgProjectManagementColored2 = function SvgProjectManagementColored2(props) {
    return /*#__PURE__*/ react.createElement("svg", project_management_colored_2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), project_management_colored_2_path || (project_management_colored_2_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M11.403 17.439H8.258A1.265 1.265 0 0 1 7 16.176V6.628a1.256 1.256 0 0 1 1.258-1.262h11.32c.335 0 .654.132.89.369s.369.558.369.893V9.21M7.33 9.184h10.377"
    })), project_management_colored_2_path2 || (project_management_colored_2_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M10.657 4.809v1.358M17.982 4.75v1.358"
    })), project_management_colored_2_rect || (project_management_colored_2_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 6,
        x: 15,
        y: 14,
        stroke: "#000",
        strokeWidth: 1.5,
        rx: 0.804
    })));
};
/* harmony default export */ var project_management_colored_2 = (SvgProjectManagementColored2);

;// CONCATENATED MODULE: ./static/svg/header/monday_work_management_square.svg
var monday_work_management_square_path, monday_work_management_square_path2, monday_work_management_square_path3, monday_work_management_square_defs;
function monday_work_management_square_extends() {
    monday_work_management_square_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return monday_work_management_square_extends.apply(this, arguments);
}

var SvgMondayWorkManagementSquare = function SvgMondayWorkManagementSquare(props) {
    return /*#__PURE__*/ react.createElement("svg", monday_work_management_square_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 72,
        height: 72,
        fill: "none",
        viewBox: "0 0 72 72"
    }, props), monday_work_management_square_path || (monday_work_management_square_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M16.367 52.545c-2.709-1.847-3.367-5.482-1.47-8.12l16.007-22.259c1.172-1.63 3.045-2.497 4.945-2.486 1.896-.008 3.766.86 4.936 2.486l16.012 22.266c1.896 2.637 1.238 6.272-1.47 8.119-2.71 1.846-6.442 1.205-8.339-1.432L35.844 35.623l-11.139 15.49c-1.896 2.637-5.63 3.278-8.338 1.432"
    })), monday_work_management_square_path2 || (monday_work_management_square_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2108_574604)",
        d: "M16.372 18.724c-2.709 1.847-3.367 5.482-1.47 8.119l16 22.25c1.168 1.624 3.032 2.49 4.925 2.486 1.904.015 3.783-.853 4.958-2.486l16-22.25c1.897-2.637 1.239-6.272-1.47-8.119s-6.442-1.206-8.338 1.432L35.843 35.637 24.71 20.156c-1.897-2.638-5.63-3.279-8.338-1.432"
    })), monday_work_management_square_path3 || (monday_work_management_square_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#7E7EFF",
        d: "m28.532 25.47-7.31 10.163 7.31 10.164 7.31-10.164z"
    })), monday_work_management_square_defs || (monday_work_management_square_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2108_574604",
        x1: 39.285,
        x2: 37.456,
        y1: 34.624,
        y2: 52.175,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#8F8FFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#BABAFD"
    })))));
};
/* harmony default export */ var monday_work_management_square = (SvgMondayWorkManagementSquare);

// EXTERNAL MODULE: ./static/svg/header/monday_crm_square.svg
var monday_crm_square = __webpack_require__(91276);
// EXTERNAL MODULE: ./static/svg/header/monday_marketer_square.svg
var monday_marketer_square = __webpack_require__(93216);
// EXTERNAL MODULE: ./static/svg/header/monday_projects_square.svg
var monday_projects_square = __webpack_require__(52165);
// EXTERNAL MODULE: ./static/svg/header/monday_dev_square.svg
var monday_dev_square = __webpack_require__(1828);
;// CONCATENATED MODULE: ./static/svg/header/wm_logo.svg
var wm_logo_path, wm_logo_path2, wm_logo_path3, wm_logo_path4, wm_logo_path5, wm_logo_path6, wm_logo_path7, wm_logo_defs;
function wm_logo_extends() {
    wm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return wm_logo_extends.apply(this, arguments);
}

var SvgWmLogo = function SvgWmLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", wm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), wm_logo_path || (wm_logo_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1860_128182)",
        d: "M15.436 2.592c0-1.421-1.097-2.573-2.45-2.573s-2.45 1.152-2.45 2.573v2.829c0 1.421 1.096 2.574 2.45 2.574 1.353 0 2.45-1.153 2.45-2.574z"
    })), wm_logo_path2 || (wm_logo_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1860_128182)",
        d: "M5.846 6.202c-1.288-.44-2.67.3-3.089 1.65-.418 1.352.287 2.803 1.575 3.243l2.562.874c1.288.439 2.67-.3 3.09-1.651.417-1.352-.288-2.803-1.575-3.242z"
    })), wm_logo_path3 || (wm_logo_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_1860_128182)",
        d: "M6.148 16.894c-.796 1.15-.553 2.759.541 3.594s2.628.58 3.424-.57l1.584-2.289c.796-1.15.553-2.759-.542-3.594-1.094-.835-2.627-.58-3.423.57z"
    })), wm_logo_path4 || (wm_logo_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint3_linear_1860_128182)",
        d: "M15.93 19.889c.796 1.15 2.329 1.405 3.424.57s1.337-2.444.54-3.594l-1.583-2.289c-.796-1.15-2.328-1.405-3.423-.57s-1.338 2.444-.542 3.594z"
    })), wm_logo_path5 || (wm_logo_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6161FF",
        d: "M13.01 13.86c1.342 0 2.43-1.143 2.43-2.553s-1.088-2.552-2.43-2.552-2.432 1.142-2.432 2.552 1.089 2.553 2.432 2.553M5.077 11.206c1.35 0 2.445-1.15 2.445-2.566 0-1.418-1.094-2.567-2.445-2.567S2.633 7.223 2.633 8.64s1.094 2.566 2.444 2.566M12.986 5.142c1.353 0 2.449-1.151 2.449-2.571S14.339 0 12.986 0s-2.449 1.151-2.449 2.57c0 1.42 1.096 2.572 2.45 2.572M8.129 20.986c1.355 0 2.453-1.153 2.453-2.576 0-1.422-1.098-2.575-2.453-2.575s-2.453 1.153-2.453 2.575 1.098 2.576 2.453 2.576M17.92 20.959c1.352 0 2.448-1.15 2.448-2.57s-1.095-2.57-2.447-2.57-2.448 1.15-2.448 2.57 1.096 2.57 2.448 2.57"
    })), wm_logo_path6 || (wm_logo_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint4_linear_1860_128182)",
        d: "M20.154 6.201c1.288-.439 2.67.3 3.089 1.651.418 1.352-.287 2.803-1.575 3.242l-2.562.874c-1.288.44-2.671-.3-3.09-1.65-.417-1.352.288-2.803 1.575-3.243z"
    })), wm_logo_path7 || (wm_logo_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6161FF",
        d: "M20.923 11.206c-1.35 0-2.445-1.15-2.445-2.567s1.095-2.566 2.445-2.566 2.444 1.149 2.444 2.566c0 1.418-1.094 2.567-2.444 2.567"
    })), wm_logo_defs || (wm_logo_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1860_128182",
        x1: 12.97,
        x2: 13.029,
        y1: -4.924,
        y2: 8.508,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1860_128182",
        x1: -1.726,
        x2: 10.566,
        y1: 6.341,
        y2: 10.092,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_1860_128182",
        x1: 3.935,
        x2: 11.898,
        y1: 24.497,
        y2: 13.963,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint3_linear_1860_128182",
        x1: 22.134,
        x2: 14.085,
        y1: 24.448,
        y2: 13.987,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint4_linear_1860_128182",
        x1: 27.726,
        x2: 15.434,
        y1: 6.341,
        y2: 10.091,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })))));
};
/* harmony default export */ var wm_logo = ((/* unused pure expression or super */ null && (SvgWmLogo)));

;// CONCATENATED MODULE: ./static/svg/header/mobile_crm_logo.svg
var mobile_crm_logo_path, _ellipse, _ellipse2, mobile_crm_logo_path2, mobile_crm_logo_defs;
function mobile_crm_logo_extends() {
    mobile_crm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_crm_logo_extends.apply(this, arguments);
}

var SvgMobileCrmLogo = function SvgMobileCrmLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", mobile_crm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_crm_logo_path || (mobile_crm_logo_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#00A0A0",
        d: "M16.646 12.818a.563.563 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.32 8.32 0 0 0 4.817 2.914 8.26 8.26 0 0 0 5.554-.832 8.4 8.4 0 0 0 3.77-4.2c.739-1.798.836-3.8.276-5.662a8.4 8.4 0 0 0-3.345-4.553 8.27 8.27 0 0 0-7.124-1.032 8.3 8.3 0 0 0-1.691.747 8.4 8.4 0 0 1 3.079 3.131l.002-.036.017.03a8.5 8.5 0 0 1 1.067 3.56"
    })), _ellipse || (_ellipse = /*#__PURE__*/ React.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "#fff",
        rx: 8.333,
        ry: 8.413
    })), _ellipse2 || (_ellipse2 = /*#__PURE__*/ React.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "url(#paint0_linear_1_20)",
        rx: 8.333,
        ry: 8.413
    })), mobile_crm_logo_path2 || (mobile_crm_logo_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1_20)",
        d: "M12.502 20.7a8.43 8.43 0 0 0 4.165-7.287c.007-.34-.021-.595-.021-.595a.57.57 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.4 8.4 0 0 0 2.278 1.95"
    })), mobile_crm_logo_defs || (mobile_crm_logo_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_20",
        x1: 2.538,
        x2: 16.723,
        y1: 8.363,
        y2: 15.544,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D2D2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2",
        stopOpacity: 0.29
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1_20",
        x1: 17.571,
        x2: 4.308,
        y1: 17.755,
        y2: 15.018,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00A0A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2"
    })))));
};
/* harmony default export */ var mobile_crm_logo = ((/* unused pure expression or super */ null && (SvgMobileCrmLogo)));

;// CONCATENATED MODULE: ./static/svg/header/mobile_marketer_logo.svg
var mobile_marketer_logo_g, mobile_marketer_logo_defs;
function mobile_marketer_logo_extends() {
    mobile_marketer_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_marketer_logo_extends.apply(this, arguments);
}

var SvgMobileMarketerLogo = function SvgMobileMarketerLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", mobile_marketer_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_marketer_logo_g || (mobile_marketer_logo_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1_21)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#CA0C6B",
        d: "M9.455 11.386v9.679c0 .36.292.653.653.653h4.784a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-9.678C25 7.307 21.52 4 17.227 4s-7.772 3.307-7.772 7.386"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1_21)",
        d: "M0 11.386v9.679c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.784a.654.654 0 0 0 .654-.654v-9.678C15.546 7.307 12.066 4 7.773 4S0 7.307 0 11.386"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F8C3DD",
        d: "M0 16.026h6.09v5.153a.54.54 0 0 1-.54.54H.54a.54.54 0 0 1-.54-.54zM9.455 16.026h6.09v5.153a.54.54 0 0 1-.539.54H9.995a.54.54 0 0 1-.54-.54zM18.91 16.026H25v5.153a.54.54 0 0 1-.539.54h-5.01a.54.54 0 0 1-.54-.54z"
    }))), mobile_marketer_logo_defs || (mobile_marketer_logo_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_21",
        x1: -0.507,
        x2: 24.777,
        y1: 20.464,
        y2: 17.216,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF158A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.766,
        stopColor: "#FF158A",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1_21"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_marketer_logo = ((/* unused pure expression or super */ null && (SvgMobileMarketerLogo)));

;// CONCATENATED MODULE: ./static/svg/header/mobile_projects_logo.svg
var mobile_projects_logo_path, mobile_projects_logo_path2, mobile_projects_logo_path3, mobile_projects_logo_defs;
function mobile_projects_logo_extends() {
    mobile_projects_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_projects_logo_extends.apply(this, arguments);
}

var SvgMobileProjectsLogo = function SvgMobileProjectsLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", mobile_projects_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1_23)"
    }, mobile_projects_logo_path || (mobile_projects_logo_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1_23)",
        d: "M6.25 4.333c0-.583.308-1.12.807-1.412L11.693.218a1.6 1.6 0 0 1 1.614 0l4.636 2.703c.5.291.807.83.807 1.412v6.347l-6.25 3.643-6.25-3.643z"
    })), mobile_projects_logo_path2 || (mobile_projects_logo_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1_23)",
        d: "M6.25 10.68c-1.81 1.062-3.628 2.112-5.443 3.17-.5.291-.807.83-.807 1.412v5.405c0 .582.308 1.12.807 1.412l4.636 2.703c.5.29 1.115.29 1.614 0l5.443-3.17v-7.288z"
    })), mobile_projects_logo_path3 || (mobile_projects_logo_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_1_23)",
        d: "M24.193 13.85c.5.29.807.83.807 1.412v5.405c0 .582-.308 1.12-.807 1.412l-4.636 2.703c-.5.29-1.115.29-1.614 0l-5.443-3.17v-7.288l6.25-3.644c1.811 1.062 3.629 2.112 5.443 3.17"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint3_linear_1_23)",
        d: "M6.25 11.15c0-.29.154-.56.404-.706l5.443-3.173a.8.8 0 0 1 .807 0l5.442 3.173c.25.146.404.415.404.706v6.347c0 .291-.154.56-.404.706l-5.442 3.173a.8.8 0 0 1-.807 0l-5.443-3.173a.82.82 0 0 1-.404-.706z",
        style: {
            mixBlendMode: "multiply"
        }
    })), mobile_projects_logo_defs || (mobile_projects_logo_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_23",
        x1: 6.25,
        x2: 18.806,
        y1: 3.401,
        y2: 10.585,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1_23",
        x1: 12.5,
        x2: -0.056,
        y1: 14.318,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_1_23",
        x1: 12.5,
        x2: 25.056,
        y1: 14.317,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint3_linear_1_23",
        x1: 12.5,
        x2: 12.5,
        y1: 7.162,
        y2: 21.485,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FDAB3D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00",
        stopOpacity: 0.51
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1_23"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_projects_logo = ((/* unused pure expression or super */ null && (SvgMobileProjectsLogo)));

;// CONCATENATED MODULE: ./static/svg/header/dev_logo_new.svg
var dev_logo_new_path, dev_logo_new_path2, dev_logo_new_path3, dev_logo_new_defs;
function dev_logo_new_extends() {
    dev_logo_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_logo_new_extends.apply(this, arguments);
}

var SvgDevLogoNew = function SvgDevLogoNew(props) {
    return /*#__PURE__*/ React.createElement("svg", dev_logo_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 18,
        fill: "none",
        viewBox: "0 0 25 18"
    }, props), dev_logo_new_path || (dev_logo_new_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_2426_1287)",
        fillRule: "evenodd",
        d: "M9.415 2.535C9.415 1.135 10.55 0 11.95 0a8.54 8.54 0 0 1 8.54 8.54 8.54 8.54 0 0 1-8.54 8.542H2.535a2.535 2.535 0 0 1 0-5.07h9.415a3.47 3.47 0 0 0 3.47-3.471 3.47 3.47 0 0 0-3.47-3.47 2.535 2.535 0 0 1-2.535-2.536",
        clipRule: "evenodd"
    })), dev_logo_new_path2 || (dev_logo_new_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#00CA72",
        fillRule: "evenodd",
        d: "M3.55 8.54A8.54 8.54 0 0 1 12.093 0a2.535 2.535 0 1 1 0 5.07 3.47 3.47 0 0 0-3.47 3.47 3.47 3.47 0 0 0 3.47 3.471h10.407v5.07H12.092a8.54 8.54 0 0 1-8.541-8.54",
        clipRule: "evenodd"
    })), dev_logo_new_path3 || (dev_logo_new_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#00CA72",
        d: "M24.747 13.943a.86.86 0 0 1 0 1.219l-1.683 1.673c-.542.54-1.466.155-1.466-.61V12.88c0-.765.924-1.149 1.466-.61z"
    })), dev_logo_new_defs || (dev_logo_new_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_2426_1287",
        x1: 15.536,
        x2: 14.014,
        y1: 5.721,
        y2: 12.798,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00CA72"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.906,
        stopColor: "#00CA72",
        stopOpacity: 0.6
    })))));
};
/* harmony default export */ var dev_logo_new = ((/* unused pure expression or super */ null && (SvgDevLogoNew)));

;// CONCATENATED MODULE: ./static/svg/header/service_logo.svg
var service_logo_path, service_logo_path2, service_logo_defs;
function service_logo_extends() {
    service_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return service_logo_extends.apply(this, arguments);
}

var SvgServiceLogo = function SvgServiceLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", service_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        fill: "none",
        viewBox: "0 0 23 23"
    }, props), service_logo_path || (service_logo_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF4D77",
        fillRule: "evenodd",
        d: "M4.835 4.715C3.01 5.484 2.12 7.406 2.948 9.37c1.068 2.538 5.77 3.979 5.992 4.01.198.032.43-.083.43-.303s-.43-2.043-.43-2.172.072-.245.197-.297c.124-.051 5.577-2.363 7.385-3.123a3.523 3.523 0 0 0 1.887-4.654C17.63.983 15.573.178 13.755.943s-7.096 3.005-8.92 3.772",
        clipRule: "evenodd"
    })), service_logo_path2 || (service_logo_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_162_137261)",
        fillRule: "evenodd",
        d: "M17.468 18.595c1.824-.769 2.713-2.691 1.887-4.654-1.07-2.538-5.771-3.97-5.992-4.002-.2-.03-.432.084-.432.304s.432 2.033.432 2.162c0 .13-.073.246-.197.298s-5.578 2.363-7.386 3.123a3.523 3.523 0 0 0-1.887 4.654c.778 1.848 2.836 2.652 4.654 1.887 1.82-.765 7.096-3.006 8.92-3.772",
        clipRule: "evenodd"
    })), service_logo_defs || (service_logo_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_162_137261",
        x1: 14.58,
        x2: 14.211,
        y1: 23.441,
        y2: 10.321,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF4D77"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.47,
        stopColor: "#FF4D77",
        stopOpacity: 0.85
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF4D77",
        stopOpacity: 0.4
    })))));
};
/* harmony default export */ var service_logo = ((/* unused pure expression or super */ null && (SvgServiceLogo)));

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js
// Header menus data =================================================================
















// import BoardsColoredIcon from "static/svg/header/boards_colored.svg";








// import EnterpriseAgilityColoredIcon from "static/svg/header/enterprise_agility_colored.svg";












// platform icons





var PRODUCTS_MENU_ID = "products";
var USE_CASES_MENU_ID = "use-cases";
var FEATURES_MENU_ID = "features";
var RESOURCES_MENU_ID = "resources";
var AI_MENU_ID = "ai";
// structured header
var SOLUTIONS_MENU_ID = "solutions";
var TEAMS_MENU_ID = "teams";
var PLATFORM_MENU_ID = "platform";
var CUSTOMERS_MENU_ID = "customers";
var DESKTOP_HEADER_BASE_CLASS_NAME = "base-header-desktop-component";
var PRODUCTS_PRODUCTS_SECTION_ID = "products";
var PRODUCTS_MORE_SECTION_ID = "more";
var BY_TEAM_SECTION_ID = "by-team";
var BY_BUSINESS_SIZE_SECTION_ID = "by-business-size";
var BY_INDUSTRY_SECTION_ID = "by-industry";
var KEY_FEATURES_SECTION_ID = "key-features";
var RESOURCES_LEARN_SECTION_ID = "learn";
var RESOURCES_CONNECT_SECTION_ID = "connect";
var RESOURCES_EXPLORE_SECTION_ID = "explore";
var TOP_STORIES_SECTION_ID = "top-stories";
var ICON_TYPES = {
    fill: "fill",
    outline: "outline"
};
var MENU_SECTION_CLASSNAMES = {
    products: "products",
    mondayProducts: "mondayProducts",
    moreProducts: "moreProducts",
    useCases: "use-cases",
    features: "features",
    resources: "resources",
    integrations: "integrations",
    addOns: "addOns"
};
var MENU_SECTION_ITEM_TYPE = {
    base: "base",
    product: "product",
    secondaryProduct: "secondary-product",
    useCase: "use-case",
    useCaseByWorkflow: "use-case-by-workflow",
    feature: "feature",
    resource: "resource",
    story: "story",
    byTeam: "by-team",
    byIndustry: "by-industry",
    innerMenuBottomItem: "inner-menu-bottom-item",
    integration: "integration",
    addOn: "addOn",
    ai: "ai"
};
var mobileProductsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        subtitle: "header.products.section.withWm.text.subtitle",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/WM.svg",
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/CRM.svg",
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/DEV.svg",
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/SVC.svg",
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayService.title",
                subtitle: "header.tabs.products.mondayService.subtitle",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], 0.16),
                hasBetaTag: true
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var productsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/CRM.svg",
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME],
                    backgroundColor: (0,general/* hexToRgba */.a7)("#babafd", 0.2),
                    list: [
                        "header.tabs.products.mondayWorkManagement.tags.projectAndTaskManagement",
                        "header.tabs.products.mondayWorkManagement.tags.operations",
                        "header.tabs.products.mondayWorkManagement.tags.buildYourOwn"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/CRM.svg",
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: "https://dapulse-res.cloudinary.com/image/upload/DEV.svg",
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#015727",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayDev.tags.roadmapPlanning",
                        "header.tabs.products.mondayDev.tags.bugTracking",
                        "header.tabs.products.mondayDev.tags.scrumAndKanban"
                    ]
                }
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var useCasesSectionMenuItems = [
    {
        id: BY_TEAM_SECTION_ID,
        title: "header.useCases.section.byTeam",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: marketing_colored,
                iconColor: color_consts.MARKETING_RED_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.marketing",
                url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
                icon: project_management_colored_2,
                title: "header.tabs.workflows.byWorkflow.projectManagement.title",
                description: "header.tabs.workflows.byWorkflow.projectManagement.description",
                url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: sales_colored_1,
                iconColor: color_consts.CRM_GREEN_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.sales",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: dev_colored,
                iconColor: color_consts.DEV_GREEN_COLOR_NAME,
                title: "header.tabs.teams.byTeam.productDevelopers",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: operations_colored,
                title: "header.tabs.workflows.byTeam.operations",
                url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: it_colored_1,
                title: "header.tabs.workflows.byTeam.it",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: hr_colored_1,
                title: "header.tabs.workflows.byTeam.hr",
                url: links/* HR_USE_CASES_LINK */.n$n,
                outline: true
            }
        ]
    },
    {
        id: BY_BUSINESS_SIZE_SECTION_ID,
        title: "header.useCases.section.byBusinessSize",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: enterprise_colored_1,
                title: "header.tabs.workflows.byBusinessSize.enterprise",
                url: links/* ENTERPRISE_PAGE_LINK */.RVF
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: small_business_colored_1,
                title: "header.tabs.workflows.byBusinessSize.smallBusiness",
                url: links/* SMB_PAGE_LINK */.qDl
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: nonprofit_colored,
                title: "header.tabs.workflows.byBusinessSize.nonprofit",
                url: links/* NGO_PAGE_LINK */.htU
            }
        ]
    },
    {
        id: BY_INDUSTRY_SECTION_ID,
        title: "header.tabs.solutions.byTeam.industries.title",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: retail_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.retail.title",
                url: links/* RETAIL_PAGE_LINK */.fjW
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: media_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.media.title",
                url: links/* MEDIA_PAGE_LINK */.Dx_
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: construction_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.construction.title",
                url: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: government_icon,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solution.government",
                url: links/* GOVERNMENT_PAGE_LINK */.SUu
            }
        ]
    }
];
var featuresSectionMenuItems = [
    {
        id: KEY_FEATURES_SECTION_ID,
        maxNumberOfItemsInColumn: 2,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: dashboards_colored,
                title: "header.tabs.features.keyFeatures.dashboards.title",
                description: "header.tabs.features.keyFeatures.dashboards.description",
                outline: true,
                url: links/* DASHBOARDS_PAGE_LINK */.yCu
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: integrations_colored,
                title: "header.tabs.features.keyFeatures.integrations.title",
                description: "header.tabs.features.keyFeatures.integrations.description",
                outline: true,
                url: links/* INTEGRATIONS_PAGE_LINK */.oUX
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: automations_colored,
                title: "header.tabs.features.keyFeatures.automations.title",
                description: "header.tabs.features.keyFeatures.automations.description",
                outline: true,
                url: links/* AUTOMATIONS_PAGE_LINK */.cPO
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: ai_icon,
                title: "header.tabs.features.keyFeatures.ai.title",
                description: "header.tabs.features.keyFeatures.ai.description",
                outline: true,
                url: links/* AI_PAGE_LINK */.lro
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: kanban_colored,
                title: "header.tabs.features.keyFeatures.kanban.title",
                description: "header.tabs.features.keyFeatures.kanban.description",
                outline: true,
                url: links/* KANBAN_PAGE_LINK */.ivN
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: docs_colored,
                title: "header.tabs.features.keyFeatures.docs.title",
                description: "header.tabs.features.keyFeatures.docs.description",
                outline: true,
                url: links/* WORKDOCS_PAGE_LINK */.RdE
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: gantt_colored,
                title: "header.tabs.features.keyFeatures.gantt.title",
                description: "header.tabs.features.keyFeatures.gantt.description",
                outline: true,
                url: links/* GANTT_PAGE_LINK */.TA3
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: forms_icon_new,
                title: "header.tabs.features.keyFeatures.forms.title",
                description: "header.tabs.features.keyFeatures.forms.description",
                outline: true,
                url: links/* FORMS_PAGE_LINK */.ua2
            }
        ]
    }
];
var resourcesSectionMenuItems = [
    {
        id: RESOURCES_LEARN_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.resources,
        title: "header.tabs.resources.section.learn",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.knowledgeBase.title",
                description: "header.tabs.resources.learn.knowledgeBase.description",
                url: links/* HELP_CENTER_LINK */.j3e
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.whatsNew.title",
                description: "header.tabs.resources.learn.whatsNew.description",
                url: links/* WHATS_NEW_PAGE_LINK */.Lmq
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.aboutUs.title",
                description: "header.tabs.resources.learn.aboutUs.description",
                url: links/* ABOUT_US_PAGE_LINK */.iAZ
            },
            // {
            //   itemType: MENU_SECTION_ITEM_TYPE.resource,
            //   title: "header.tabs.resources.learn.resourcesHub.title",
            //   description: "header.tabs.resources.learn.resourcesHub.description",
            // },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.blog.title",
                description: "header.tabs.resources.learn.blog.description",
                url: links/* BLOG_PAGE_LINK */.xR0
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.BuilderCertificationsText.title",
                description: "header.tabs.resources.connect.BuilderCertificationsText.description",
                url: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
            }
        ]
    },
    {
        id: RESOURCES_CONNECT_SECTION_ID,
        title: "header.tabs.resources.section.connect",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.support.title",
                description: "header.tabs.resources.connect.support.description",
                url: links/* SUPPORT_PAGE_LINK */.jX6
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.partners.title",
                description: "header.tabs.resources.connect.partners.description1",
                url: links/* PARTNERS_PAGE_LINK */.MW2
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.globalEvents.title",
                description: "header.tabs.resources.connect.globalEvents.description",
                url: links/* GLOBAL_EVENTS_PAGE_LINK */.O5z
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.resources.connect.community.title",
                description: "header.tabs.resources.connect.community.description",
                url: links/* COMMUNITY_LINK */.gcb
            }
        ]
    },
    {
        id: RESOURCES_EXPLORE_SECTION_ID,
        title: "header.tabs.resources.section.build",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.appsDeveloper.title",
                description: "header.tabs.resources.explore.appsDeveloper.description",
                url: links/* APPS_DEVELOPER_LINK */.FE7
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.templateCenter.title",
                description: "header.tabs.resources.explore.templateCenter.description1",
                url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.spaces.title",
                description: "header.tabs.resources.explore.spaces.description",
                url: links/* MONDAY_SPACES_PAGE_LINK */.UN3
            }
        ]
    },
    {
        id: TOP_STORIES_SECTION_ID,
        title: "header.tabs.resources.section.customersStories",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 2,
        backgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME,
        hideOnMobile: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.story,
                hoverBackgroundColor: colors/* default */.Z[color_consts.WHITE_COLOR_NAME],
                imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Header_asset.png",
                description: "header.tabs.resources.topStories.whyCustomersUse",
                url: links/* CUSTOMERS_PAGE_LINK */.iN6,
                button: true
            }
        ]
    }
];
var aiSectionMenuItems = [
    {
        id: AI_MENU_ID,
        maxNumberOfItemsInColumn: 3,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.ai,
                icon: ai_icon,
                title: "header.tabs.products.aiOverview",
                url: links/* AI_PAGE_LINK */.lro
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.ai,
                icon: ai_icon,
                title: "header.tabs.products.mcp",
                url: links/* MCP_PAGE_LINK */.EK8
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.ai,
                icon: ai_icon,
                title: "header.tabs.products.aiTrustCenter",
                url: links/* AI_TRUST_CENTER_SITE_LINK */.FRK
            }
        ]
    }
];
var _obj;
/** * Structured Header sections definitions - End ** */ var SectionsHeadersMenuItemsMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, PRODUCTS_MENU_ID, productsSectionMenuItems), (0,_define_property/* default */.Z)(_obj, USE_CASES_MENU_ID, useCasesSectionMenuItems), (0,_define_property/* default */.Z)(_obj, FEATURES_MENU_ID, featuresSectionMenuItems), (0,_define_property/* default */.Z)(_obj, RESOURCES_MENU_ID, resourcesSectionMenuItems), (0,_define_property/* default */.Z)(_obj, AI_MENU_ID, aiSectionMenuItems), _obj);
// ===========================================================================================
// Header service functions
var isDesktopMinisiteSecondaryMenuActive = function() {
    var headerElement = document.querySelector(".".concat(DESKTOP_HEADER_BASE_CLASS_NAME));
    if (!headerElement) return false;
    return headerElement.classList.contains("scroll-started") && !headerElement.classList.contains("scrolled-threshold");
};
var shouldRenderSecondaryMenu = function(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig) {
    return isClusterMiniSitePage && (0,cluster_config_service/* isMiniSiteConfigValid */.cJ)(pageClusterConfig, {
        useProductMiniSiteConfig: useProductMiniSiteConfig
    });
};


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ })

}]);